import Echo from 'laravel-echo';
import {
    API_URL,
    ECHO_SERVICE_APP_KEY,
    ECHO_SERVICE_HOST,
    ECHO_SERVICE_PATH,
    ECHO_SERVICE_PORT,
} from '@/app/core/common/config';
import Pusher from 'pusher-js';

class CustomEcho extends Echo {
    updateAuthorizationToken(token) {
        this.connector.options.auth.headers.Authorization = `Bearer ${token}`;
        this.connector.options.userAuthentication.headers.Authorization = `Bearer ${token}`;
    }
}

window.Pusher = Pusher;

let wsHost = ECHO_SERVICE_HOST;
let wsPort = ECHO_SERVICE_PORT;

if (ECHO_SERVICE_HOST && /:\/\//.test(ECHO_SERVICE_HOST)) {
    const parsedHost = new URL(ECHO_SERVICE_HOST);
    wsHost = parsedHost.hostname;
    wsPort = parsedHost.port;
}

export const echoService = new CustomEcho({
    broadcaster: ECHO_SERVICE_HOST ? 'pusher' : 'null',
    wsHost,
    wsPort,
    wssPort: wsPort,
    wsPath: ECHO_SERVICE_PATH ?? undefined,
    authEndpoint: `${API_URL}/broadcasting/auth`,
    key: ECHO_SERVICE_APP_KEY,
    cluster: '1',
    enabledTransports: ['ws', 'wss'],
    forceTLS: false,
    upgrade: false,
});
